import { List } from './List'
import { employeeApi } from '@/api'
import { Employee } from '@/models/directories/Employee'
import { vm } from '@/main'

export class AuthorWorkParent extends List {
  constructor(obj) {
    super(AuthorWork, obj)
  }
}

export class AuthorWork {
  constructor(obj = {}) {
    this.id = obj?.id || null
    this.nameRus = obj?.nameRus || null
    this.firstNameEng = obj?.firstNameEng || null
    this.lastNameEng = obj?.lastNameEng || null
    this.middleNameEng = obj?.middleNameEng || null
    this.employeePosition = obj?.employeePosition || null
    this.isForeignAuthor = obj?.isForeignAuthor || false
    this.share = obj?.share || null

    this.notFoundAuthor = obj?.notFoundAuthor || Boolean(this.id && this.nameRus)
    this.employee = (obj?.employee && !this.notFoundAuthor && new Employee(obj.employee)) || null
    this.employeesList = obj?.employeesList || (obj?.employee && [new Employee(obj.employee)]) || []
    this.employeesLoading = false
    this.employeePositionsLoading = false

    this.employeePositionsByEmployee = obj?.employeePositionsByEmployee || []
  }

  getMainAuthorShortName() {
    const splitName = (this.employee?.fullName || this.nameRus)?.split(' ')?.filter(el => el)
    return splitName?.length >= 3
      ? `${splitName[0]}, ${splitName[1].slice(0, 1)}.${splitName[2].slice(0, 1)}.`
      : splitName?.length === 2
      ? `${splitName[0]}, ${splitName[1].slice(0, 1)}.`
      : splitName?.length === 1
      ? `${splitName[0]}`
      : null
  }

  getMainAuthorShortNameEng() {
    const lastNameEng = this.lastNameEng?.trim()
    const firstNameEng = this.firstNameEng?.trim()
    const middleNameEng = this.middleNameEng?.trim()

    if (lastNameEng && firstNameEng) {
      const middleNameEngLocal = middleNameEng ? `${middleNameEng.slice(0, 1)}.` : ''

      return `${lastNameEng}, ${firstNameEng.slice(0, 1)}.${middleNameEngLocal}`
    } else {
      return ''
    }
  }

  getAuthorShortNameReverse() {
    const splitName = (this.employee?.fullName?.trim() || this.nameRus?.trim())?.split(' ')?.filter(el => el)
    return splitName?.length === 3 ? `${splitName[1].slice(0, 1)}.${splitName[2].slice(0, 1)}. ${splitName[0]}` : null
  }

  getAuthorShortNameReverseEng() {
    const lastNameEng = this.lastNameEng?.trim()
    const firstNameEng = this.firstNameEng?.trim()
    const middleNameEng = this.middleNameEng?.trim()

    if (lastNameEng && firstNameEng) {
      const middleNameEngLocal = middleNameEng ? `${middleNameEng.slice(0, 1)}.` : ''

      return `${firstNameEng.slice(0, 1)}.${middleNameEngLocal} ${lastNameEng}`
    } else {
      return ''
    }
  }

  getAuthorShortNameWithoutComma() {
    const splitName = this.nameRus?.split(' ')
    return splitName?.length === 3 ? `${splitName[0]} ${splitName[1].slice(0, 1)}.${splitName[2].slice(0, 1)}.` : null
  }

  async findEmployees(val) {
    try {
      if (!val) {
        this.employeePosition = null
        this.employeePositionsByEmployee = null
        this.employee = !this.notFoundAuthor ? new Employee() : null
        this.employeesLoading = false
        return
      }
      if (val?.length >= 3 && this.employee?.fullName !== val) {
        this.employeesLoading = true
        const data = await employeeApi.findByName(val)
        this.employeesList = data ? data.filter(el => el.isActual).map(el => new Employee(el)) : []
      }
      this.employeesLoading = false
    } catch (e) {
      console.log(e)
      if (e) {
        this.employeesLoading = false
        vm.showErrorMessage(e, 'Не удалось получить список сотрудников')
      } else this.employeesLoading = true
    }
  }

  getForAPI() {
    return {
      id: this.id,
      nameRus: this.nameRus,
      firstNameEng: this.firstNameEng,
      lastNameEng: this.lastNameEng,
      middleNameEng: this.middleNameEng,
      employeePosition: this.employeePosition,
      employee: this.employee,
      share: this.share,
      isForeignAuthor: this.isForeignAuthor,

      notFoundAuthor: this.notFoundAuthor,
      employeePositionsByEmployee: this.employeePositionsByEmployee
    }
  }
}
